import React, { useState, useEffect } from 'react';

const Scorers = () => {
  const [scorers, setScorers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://tournament-be.onrender.com/api';
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Fetch scorers data from API
  useEffect(() => {
    const fetchScorers = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/scorers`);

        if (!response.ok) {
          throw new Error(`Failed to load scorers: ${response.status}`);
        }

        const data = await response.json();
        setScorers(data);
      } catch (err) {
        setError(err.message);
        console.error('Scorers fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchScorers();

const intervalId = setInterval(() => {
      fetchScorers();
    }, 300000); // Refresh standings every 5 minutes

    return () => clearInterval(intervalId); // Cleanup interval on component unmount 

  }, []);

  // Loading state
  if (loading) {
    return (
      <div className="scorers-page main-content">
       <div className="d-flex flex-column align-items-center justify-content-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Loading scorers...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="scorers-page main-content">
        <div className="error-container">
          <h2>Hiba a góllövők betöltésekor</h2>
          <p>{error}</p>
          <p>Kérlek próbáld meg újra később.</p>
        </div>
      </div>
    );
  }

  // Render scorers table
  return (

    <div className="scorers-page main-content">
      <div className="scorers-container">
        <div className="group-header">
          <h2>Góllövőlista</h2>
        </div>
        <table className="styled-table scorers-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Játékos</th>
              <th>Csapat</th>
              <th>Gólok</th>
            </tr>
          </thead>
          <tbody>
            {scorers.map((scorer, index) => (
              <tr key={scorer.id || index}>
                <td>{index + 1}.</td>
                <td>{scorer.player}</td>
                <td>{scorer.team}</td>
                <td>{scorer.goals}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Scorers;
